import debounce from "@wwdev/functions/debounce";

class Overview {
	constructor(config) {
		this.config = Object.assign({
			scope: '.opleiding-module',
			form: '[data-opleiding="filters-form"]',
			filters: '[data-opleiding="filters"]',
			grid: '[data-opleiding="grid"]',
			signUp: '[data-opleiding="opleiding-signup"]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initForm();
		this.addEventListeners();
	}

	initForm() {
		// Set form course title.
		let $signUp = this.$scope.find(this.config.signUp);
		let registration_closed = $signUp.data('registration-closed');
		if (registration_closed) {
			this.$scope.find('input[name=_token]').remove();
			this.$scope.find('input[name=js_check]').remove();
		} else {
			let title = $signUp.data('title');
			this.$scope.find('input[name=naam-cursus-85]').val(title);
		}
	}

	addEventListeners() {
		$(document).off('.opleiding')
			.on('change.opleiding', '.filter-option input', (e) => $(e.currentTarget).closest('label').toggleClass('active'))
			.on('click.opleiding', '.filter-option', debounce(this.filter.bind(this), 300));
	}

	filter() {
		let $form = $(document).find(this.config.form);
		let formdata = new FormData($form[0]);
		let query = new URLSearchParams(formdata).toString()
		history.pushState($form.serialize(), '', '?' + query);

		formdata.append('ajax', true);
		formdata.append('action', 'filter');

		$.ajax({
			url: $form.attr('action'),
			method: 'get',
			data: (new URLSearchParams(formdata).toString()),
			success: (response) => {
				this.$scope.find(this.config.filters).html(response.filters);
				this.$scope.find(this.config.grid).html(response.grid);
			}
		})
	}
}

export default new Overview;